import { useEffect, useState } from 'react'
import Styles from '../style/missionComplete.module.scss';
import PerfectButtonIconLeft from '../../../../assets/svg/PerfectButtonIconLeft';
import PerfectButtonIconRight from '../../../../assets/svg/PerfectButtonIconRight';
import { useNavigate } from 'react-router-dom';
import PlayPart from '../Qna/PlayPart';
import LifiLine from '../Qna/component/LifiLine';
import authAxios from '../../../../config/authAxios';
const MissionComplete = ({ currentMission = null, missionData = {}, timeTaken = 0, challengeID = null, missionId = null }) => {
	const [startNext, setStartnext] = useState(false)
	const navigation = useNavigate()
	const handleNext = () => {
		if (missionData?.isPassed) {
			setStartnext(true)
		} else {
			navigation("/home-challenge")
		}
	}
	const [history, setHistory] = useState({
		correctAns : 0,
		totalQues : 0,
		roundCompleted : 0
	})

	const fetchMissionHistory = async () => {
		try {
			const response = await authAxios.post(`/users/api/challange-mission/history`, {
				challangeId: challengeID,
				missionId: missionId,
				currentMission: currentMission
			});
			setHistory(response?.data?.data)
		} catch (error) {
			console.error(error);
		}
	}
	useEffect(() => {
		fetchMissionHistory()
	}, [])
	return (
		<>
			{startNext ? <PlayPart time_criteria={missionData?.missionQuestion?.time_criteria} qnaData={missionData} chId={challengeID} /> :
				<div className={Styles.container_text}>
					<div className={Styles.container_box1}>
						<p className={Styles.text1}>{missionData?.isPassed ? "Perfect!!" : "Oops!!"}</p>
						<p className={Styles.text2}>{missionData?.isPassed ? "You are going good" : "Better Luck next Time"}</p>
					</div>
					<div className={Styles.container_box2}>
						<div className={Styles.box1Cover}>
							<div className={Styles.box1}>
								<p className={Styles.text3}>{history?.time_taken || timeTaken}s</p>
								<p className={Styles.text4}>Time taken</p>
							</div>
						</div>
						<div className={Styles.box1Cover}>
							<div className={Styles.box2}>
								<p className={Styles.text5}>{`${history?.correctAns}/${history?.totalQues}`}</p>
								<p className={Styles.text6}>Correct</p>
							</div>
						</div>
					</div>

					<div className={Styles.container_box3}>
						<LifiLine
							available_lifelines={history?.available_lifelines}
							lifeLineUsed={history?.lifelines_used}
							lifeClick={(e) => { }}
						/>
					</div>


					<div className={Styles.container_box4}>
						<p className={Styles.text7}>{missionData?.isPassed ? `Round ${history?.roundCompleted} completed` : "Round Failed"}</p>
						<div className={Styles.text8} onClick={handleNext}><PerfectButtonIconRight /><p className={Styles.nextRoundutton}>{missionData?.isPassed ? "Next Round" : "Go to Home"}</p><PerfectButtonIconLeft /></div>
					</div>
				</div>
			}
		</>

	)
}

export default MissionComplete;
